import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/welcome.png'


const _hoisted_1 = { class: "row d-flex align-items-stretch" }
const _hoisted_2 = { class: "col-xl-5 col-lg-12 d-flex flex-column" }
const _hoisted_3 = { class: "card bg-hero-primary border-0 rounded-3 welcome-box mb-4 h-100" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "row align-items-center" }
const _hoisted_6 = { class: "col-lg-8 col-md-8 col-sm-8" }
const _hoisted_7 = { class: "border-bottom" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "d-flex flex-column gap-3" }
const _hoisted_11 = { class: "d-flex align-items-center welcome-status-item" }
const _hoisted_12 = { class: "flex-grow-1 ms-3" }
const _hoisted_13 = { class: "text-light mb-0" }
const _hoisted_14 = { class: "text-white fw-bold mb-0" }
const _hoisted_15 = { class: "d-flex align-items-center welcome-status-item" }
const _hoisted_16 = { class: "flex-grow-1 ms-3" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "text-white fw-bold mb-0" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "d-flex align-items-center welcome-status-item" }
const _hoisted_22 = { class: "flex-grow-1 ms-3" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "text-white fw-bold mb-0" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "d-flex align-items-center welcome-status-item" }
const _hoisted_28 = { class: "flex-grow-1 ms-3" }
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = { class: "text-white fw-bold mb-0" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "col-xl-7 d-flex flex-column" }
const _hoisted_34 = {
  key: 0,
  class: "row"
}
const _hoisted_35 = { class: "col-lg-6" }
const _hoisted_36 = { class: "col-lg-6 d-none" }
const _hoisted_37 = { class: "col-lg-6" }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = {
  key: 2,
  class: "row mt-0"
}
const _hoisted_40 = { class: "col-12" }

import { computed, ref, onMounted } from 'vue';
import { t } from '@/utils/i18nHelper';
import type { LastCalculationData } from '@/services/authService';
import { calculateProgressiveLiquidity } from '@/services/progressiveLiquidityService';
import { authStore } from '@/stores/auth';
import TaxBreakdownChart from './TaxBreakdownChart.vue';
import DeadlinesWidget from './DeadlinesWidget.vue';
import LiquidityStatsBoxes from './LiquidityStatsBoxes.vue';
import LiquidityScheduleTable from './LiquidityScheduleTable.vue';
import MonthlyFlowChart from './MonthlyFlowChart.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TaxDashboard',
  props: {
  lastCalculation: {
    type: Object as () => LastCalculationData,
    required: true,
  },
  hideTaxWidgets: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

// Reactive state for liquidity data
const liquidityApiResults = ref<any>(null);

const currentYear = new Date().getFullYear();

const currentYearTitle = computed(() =>
  t('fr.tax_results.current_year_title', `Totale ${currentYear}`, { currentYear })
);

const nextYear = currentYear + 1;

const nextYearTitle = computed(() =>
  t('fr.tax_results.next_year_title', `Previsione ${nextYear}`, { nextYear })
);

// Map lastCalculation data to the format expected by TaxResults components
const mappedResults = computed(() => {
  if (!props.lastCalculation?.output_data) {
    return { current: null, predictions: null };
  }

  return {
    current: props.lastCalculation.output_data.current,
    predictions: props.lastCalculation.output_data.predictions
  };
});

// Map liquidity data from API call
const mappedLiquidityResults = computed(() => {
  return liquidityApiResults.value;
});

// Get contribution regime from input data
const contributionRegime = computed(() => {
  return props.lastCalculation?.input_data?.contributionRegime || 'IVS_COMMERCIANTI';
});

// Helper function to calculate correct flat tax rate
const calculateFlatTaxRate = (yearData: any): number => {
  // If API already provides the correct rate, use it
  if (yearData?.aliquotaForfettaria) {
    return yearData.aliquotaForfettaria;
  }
  if (yearData?.aliquotaImpostaSostitutiva) {
    return yearData.aliquotaImpostaSostitutiva;
  }

  // Otherwise calculate based on form data from lastCalculation
  if (props.lastCalculation?.input_data?.isStartup && yearData?.yearsActive <= 5) {
    return 5; // 5% for startups within first 5 years
  }

  return 15; // 15% standard rate
};

const calculateChartAmounts = (data: any) => {
  if (!data) return {
    taxAmount: 0,
    inpsVariableAmount: 0,
    inpsFixedAmount: 0,
    contribSoggettivo: 0,
    contribIntegrativo: 0,
    contribMaternita: 0,
    contributionType: 'INPS'
  };

  // Verifica se è una cassa professionale
  const isProfessional = data.contributionBreakdown !== undefined;

  // Per il grafico sommiamo sempre: saldo + acconti dell'anno corrente
  // Questo mostra tutti i versamenti che l'utente deve fare nell'anno
  const taxAmountRaw = (
    (data.saldoImpostaSostitutiva || data.adjustedTaxBalance || 0) +
    (data.firstAccontoImpostaSostitutiva || 0) +
    (data.secondAccontoImpostaSostitutiva || 0)
  );
  const taxAmount = Number(taxAmountRaw.toFixed(2));

  if (isProfessional) {
    // Casse professionali: usa contributionBreakdown
    const breakdown = data.contributionBreakdown;
    return {
      taxAmount,
      inpsVariableAmount: 0,
      inpsFixedAmount: 0,
      contribSoggettivo: Number((breakdown?.soggettivo?.dovuto || 0).toFixed(2)),
      contribIntegrativo: Number((breakdown?.integrativo?.dovuto || 0).toFixed(2)),
      contribMaternita: Number((breakdown?.maternita?.importo || 0).toFixed(2)),
      contributionType: 'PROFESSIONAL'
    };
  } else {
    // INPS: logica esistente
    const inpsVariableAmountRaw = (
      (data.inpsSaldo || 0) +
      (data.firstAccontoINPS || 0) +
      (data.secondAccontoINPS || 0)
    );
    const inpsVariableAmount = Number(inpsVariableAmountRaw.toFixed(2));

    let inpsFixedAmountRaw = 0;
    if (contributionRegime.value === 'IVS_COMMERCIANTI') {
      inpsFixedAmountRaw = 4549.70;
    } else if (contributionRegime.value === 'IVS_ARTIGIANI') {
      inpsFixedAmountRaw = 4460.64;
    }
    const inpsFixedAmount = Number(inpsFixedAmountRaw.toFixed(2));

    return {
      taxAmount,
      inpsVariableAmount,
      inpsFixedAmount,
      contribSoggettivo: 0,
      contribIntegrativo: 0,
      contribMaternita: 0,
      contributionType: 'INPS'
    };
  }
};



const formatCurrency = (value: number) => {
  return new Intl.NumberFormat('it-IT', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);
};

const getUserName = () => {
  return authStore.user.value?.name || 'Utente';
};

const getNextPayment = () => {
  if (!mappedLiquidityResults.value?.events) {
    return null;
  }

  const today = new Date();
  const accumuloEvents = mappedLiquidityResults.value.events
    .filter((event: any) => {
      const eventDate = new Date(event.date);
      return eventDate > today && event.category === 'ACCUMULO';
    })
    .sort((a: any, b: any) => new Date(a.date).getTime() - new Date(b.date).getTime());

  return accumuloEvents.length > 0 ? accumuloEvents[0] : null;
};

const getAvgMonthlyRate = () => {
  return mappedLiquidityResults.value?.metadata?.avgRate || null;
};

const getTotalDeposits = () => {
  return mappedLiquidityResults.value?.statistics?.totalDeposits || null;
};

// Load liquidity data when component mounts
const loadLiquidityData = async () => {
  try {
    const liquidityPayload = {
      action: "progressive_liquidity_scheduler",
      calculationData: mappedResults.value,
      formData: props.lastCalculation.input_data,
      useSafetyMargin: props.lastCalculation.input_data?.useSafetyMargin || false,
    };

    const liquidityResult = await calculateProgressiveLiquidity(liquidityPayload);
    liquidityApiResults.value = liquidityResult;
  } catch (error: any) {
    console.error("Errore caricamento dati liquidità:", error);
    liquidityApiResults.value = null;
  }
};

onMounted(() => {
  if (mappedResults.value.current) {
    loadLiquidityData();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("h3", {
                    class: "text-white fw-semibold mb-1",
                    innerHTML: _unref(t)('tdb.welcome.greeting', 'Ciao {username} 👋', { username: getUserName() })
                  }, null, 8, _hoisted_8),
                  _createElementVNode("span", {
                    class: "text-light mb-1",
                    innerHTML: _unref(t)('tdb.welcome.line1', 'Niente ansia e niente stress, è tutto sotto controllo!')
                  }, null, 8, _hoisted_9)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined" }, "savings")
                    ], -1)),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(t)('fr.tax_results.accumulated_balance', 'Saldo Accumulato')), 1),
                      _createElementVNode("strong", _hoisted_14, "€" + _toDisplayString(formatCurrency(__props.lastCalculation.input_data.currentBalance)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined icon-bg" }, "add_card")
                    ], -1)),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("p", {
                        class: "text-light mb-0",
                        innerHTML: _unref(t)('tdb.next_payment_label', 'Il prossimo accantonamento')
                      }, null, 8, _hoisted_17),
                      _createElementVNode("strong", _hoisted_18, [
                        (getNextPayment())
                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, "€" + _toDisplayString(formatCurrency(getNextPayment().amount)), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_20, "Caricamento..."))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                      _createElementVNode("i", {
                        class: "material-symbols-outlined text-info",
                        style: {"background-color":"#def1f9"}
                      }, "calendar_month")
                    ], -1)),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("p", {
                        class: "text-light mb-0",
                        innerHTML: _unref(t)('fr.liquidity.avg_monthly_rate_small', 'La tua rata mensile')
                      }, null, 8, _hoisted_23),
                      _createElementVNode("strong", _hoisted_24, [
                        (getAvgMonthlyRate())
                          ? (_openBlock(), _createElementBlock("span", _hoisted_25, "€" + _toDisplayString(formatCurrency(getAvgMonthlyRate())), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_26, "Caricamento..."))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                      _createElementVNode("i", {
                        class: "material-symbols-outlined text-danger",
                        style: {"background-color":"#ffe8d4"}
                      }, "account_balance")
                    ], -1)),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("p", {
                        class: "text-light mb-0",
                        innerHTML: _unref(t)('fr.liquidity.total_deposits_small', 'Totale Versamenti')
                      }, null, 8, _hoisted_29),
                      _createElementVNode("strong", _hoisted_30, [
                        (getTotalDeposits())
                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, "€" + _toDisplayString(formatCurrency(getTotalDeposits())), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_32, "Caricamento..."))
                      ])
                    ])
                  ])
                ])
              ]),
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-lg-4 col-md-4 col-sm-4" }, [
                _createElementVNode("div", { class: "welcome-img text-center text-sm-end mt-4 mt-sm-0" }, [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: "welcome"
                  })
                ])
              ], -1))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_33, [
        (mappedLiquidityResults.value)
          ? (_openBlock(), _createBlock(MonthlyFlowChart, {
              key: 0,
              schedule: mappedLiquidityResults.value,
              class: "h-100"
            }, null, 8, ["schedule"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (!__props.hideTaxWidgets)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createVNode(TaxBreakdownChart, {
              title: currentYearTitle.value,
              chartTaxTotal: calculateChartAmounts(mappedResults.value.current).taxAmount,
              chartInpsVariableTotal: calculateChartAmounts(mappedResults.value.current).inpsVariableAmount,
              chartInpsFixedTotal: calculateChartAmounts(mappedResults.value.current).inpsFixedAmount,
              chartContribSoggettivo: calculateChartAmounts(mappedResults.value.current).contribSoggettivo,
              chartContribIntegrativo: calculateChartAmounts(mappedResults.value.current).contribIntegrativo,
              chartContribMaternita: calculateChartAmounts(mappedResults.value.current).contribMaternita,
              contributionType: calculateChartAmounts(mappedResults.value.current).contributionType,
              fatturato: mappedResults.value.current?.fatturatoPrecedente || 0,
              calculationDetails: mappedResults.value.current?.calculationDetails || null,
              showSummary: true,
              year: _unref(currentYear) - 1,
              summaryData: {
            fatturato: mappedResults.value.current?.fatturatoPrecedente || 0,
            aliquota: calculateFlatTaxRate(mappedResults.value.current),
            redditoImponibile: mappedResults.value.current?.redditoImponibile || (mappedResults.value.current?.fatturatoPrecedente || 0) * 0.78,
            inpsSaldo: mappedResults.value.current?.previousYearInpsSaldoPaid || 0,
            inpsAcconti: mappedResults.value.current?.previousYearInpsAdvancesPaid || 0,
            irpefAcconti: mappedResults.value.current?.previousYearTaxAdvancesPaid || 0, // TODO sbagliati qua
            totaleImposte: mappedResults.value.current?.totalDue || 0
          }
            }, null, 8, ["title", "chartTaxTotal", "chartInpsVariableTotal", "chartInpsFixedTotal", "chartContribSoggettivo", "chartContribIntegrativo", "chartContribMaternita", "contributionType", "fatturato", "calculationDetails", "year", "summaryData"])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createVNode(TaxBreakdownChart, {
              title: nextYearTitle.value,
              chartTaxTotal: calculateChartAmounts(mappedResults.value.predictions).taxAmount,
              chartInpsVariableTotal: calculateChartAmounts(mappedResults.value.predictions).inpsVariableAmount,
              chartInpsFixedTotal: calculateChartAmounts(mappedResults.value.predictions).inpsFixedAmount,
              chartContribSoggettivo: calculateChartAmounts(mappedResults.value.predictions).contribSoggettivo,
              chartContribIntegrativo: calculateChartAmounts(mappedResults.value.predictions).contribIntegrativo,
              chartContribMaternita: calculateChartAmounts(mappedResults.value.predictions).contribMaternita,
              contributionType: calculateChartAmounts(mappedResults.value.predictions).contributionType,
              fatturato: mappedResults.value.predictions?.fatturatoPrecedente || mappedResults.value.current?.fatturatoPrecedente || 0,
              calculationDetails: mappedResults.value.predictions?.calculationDetails || null,
              showSummary: true,
              year: _unref(currentYear),
              summaryData: {
            fatturato: mappedResults.value.predictions?.fatturatoPrecedente || mappedResults.value.current?.fatturatoPrecedente || 0,
            aliquota: calculateFlatTaxRate(mappedResults.value.predictions),
            redditoImponibile: mappedResults.value.predictions?.redditoImponibile || (mappedResults.value.predictions?.fatturatoPrecedente || mappedResults.value.current?.fatturatoPrecedente || 0) * 0.78,
            inpsSaldo: mappedResults.value.predictions?.previousYearInpsSaldoPaid || 0,
            inpsAcconti: mappedResults.value.predictions?.previousYearInpsAdvancesPaid || 0,
            irpefAcconti: mappedResults.value.predictions?.previousYearTaxAdvancesPaid || 0,
            totaleImposte: mappedResults.value.predictions?.totalDue || 0
          }
            }, null, 8, ["title", "chartTaxTotal", "chartInpsVariableTotal", "chartInpsFixedTotal", "chartContribSoggettivo", "chartContribIntegrativo", "chartContribMaternita", "contributionType", "fatturato", "calculationDetails", "year", "summaryData"])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createVNode(DeadlinesWidget, { results: mappedResults.value }, null, 8, ["results"])
          ])
        ]))
      : _createCommentVNode("", true),
    (mappedLiquidityResults.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
          _createVNode(LiquidityStatsBoxes, { schedule: mappedLiquidityResults.value }, null, 8, ["schedule"])
        ]))
      : _createCommentVNode("", true),
    (mappedLiquidityResults.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createVNode(LiquidityScheduleTable, { schedule: mappedLiquidityResults.value }, null, 8, ["schedule"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})